import { useRequest } from "../../../hooks/useRequest";
import { useEffect } from "react";
import { ClientApiResponse } from "../../client/types";
import { AxiosResponse } from "axios";
import routes from "../../../routes";

function useUserList() {
  const { loading, fetch, response, error } = useRequest();

  useEffect(() => {
    fetch("GET", routes.api.clients.base({}));
  }, [fetch]);

  const generateDataGridFormat = (
    users: AxiosResponse<Array<ClientApiResponse>> | undefined,
  ) => {
    if (users) {
      return users.data.map((user: ClientApiResponse) => ({
        id: user.mainUser.id,
        email: user.mainUser.email,
        firstName: user.mainUser.firstName,
        lastName: user.mainUser.lastName,
        displayName: user.name,
      }));
    }
    return [];
  };

  return {
    loading,
    userList: generateDataGridFormat(response),
    error,
  };
}

export default useUserList;
